






































import { Component, Vue } from "vue-property-decorator";
import { CloudFunctionApis } from "@/services/cloudFunctionApis";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
const TOO_MANY_FILE_UPLOADS = "You can only upload a maximum of 1 file";

const AppProps = Vue.extend({
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
});

@Component({})
export default class ImageUpload extends AppProps {
  formData = new FormData();
  uploadError: string | null = null;
  currentStatus: number | null = null;
  comments: string = "";
  fileUploadError: string = "";
  api = new CloudFunctionApis();

  constructor(props: any) {
    super(props);
  }

  get isInitial() {
    return this.currentStatus === STATUS_INITIAL;
  }
  get isSaving() {
    return this.currentStatus === STATUS_SAVING;
  }
  get isSuccess() {
    return this.currentStatus === STATUS_SUCCESS;
  }
  get isFailed() {
    return this.currentStatus === STATUS_FAILED;
  }

  reset() {
    this.currentStatus = STATUS_INITIAL;
    this.uploadError = null;
  }

  save() {
    this.currentStatus = STATUS_SAVING;

    // don't do anything if there are any file upload errors
    if (this.fileUploadError) {
      this.currentStatus = STATUS_FAILED;
      return;
    }

    this.formData.delete("comments");
    this.formData.append("comments", this.comments);
    // console.log(...this.formData);

    // set current status to success for now
    this.currentStatus = STATUS_SUCCESS;

    // Pseudo code for image upload api
    // const response = this.api.uploadImages(this.formData);

    // if (response.data) {
    //   this.currentStatus = STATUS_FAILED;
    //   this.uploadError = response.error.message;
    // } else {
    //   this.currentStatus = STATUS_SUCCESS;
    // }
  }

  filesChange(fieldName: string, fileList: any) {
    this.fileUploadError = "";
    this.formData.delete("photos");
    // If no files exists, return early
    if (!fileList.length) return;

    if (fileList.length > 1) {
      this.fileUploadError = TOO_MANY_FILE_UPLOADS;
      return;
    }

    Array.from(Array(fileList.length).keys()).forEach(x => {
      this.formData.append(fieldName, fileList[x], fileList[x].name);
    });
  }

  closeTakever() {
    this.$emit("close-takever");
  }
}
